<template>
  <div>
    <div :class="[preClass, 'container']">
    <div class="title-wrap">
        <p>企业财务分析报告</p>
      </div>
    <div :class="preClass + '-content'">
        <div>
          <p>报告期间：{{ currDateMonth }}</p>
          <p>一、企业概况</p>
          <base-table :data="companySurvey"></base-table>
        </div>
        <p>二、基本财务信息</p>
        <base-table :data="financialInfo"></base-table>
        <p>三、主要财务指标分析</p>
        <p>1、利润分析</p>
        <van-tabs>
          <van-tab :title="key" v-for="(item, key) of profitAnalysis" :key="key">
            <base-table :data="item"></base-table>
            <div class="tips-wrap" v-if='item'>
                <p v-show="key==='收入情况'" >提示：累计收入较去年同期  {{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
                <div v-if="smallScale&&key==='收入情况' &&item[2]">
                   <p v-show="item[2].value>=4000000" >请及时与会计确认增值税收入”“除开票收入、无票收入外，存在稽查查补销售额、纳税评估调整销售额，要及时与会计联系重新确认增值税累计收入 </p>
                </div>
                <p v-show="key==='成本情况'" >提示：累计成本较去年同期{{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
                <p v-show="key==='销售费用'" >提示：累计销售费用较去年同期{{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
                <p v-show="key==='管理费用'" >提示：累计管理费用较去年同期{{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
                <p v-show="key==='财务费用'" >提示：累计财务费用较去年同期{{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
                <p v-show="key==='利润总额'" >提示：累计利润总额较去年同期{{item[1].value>=item[0].value?'下降':'增长' }}  {{calcLift(item[0].value,item[1].value)}} </p>
            </div>
          </van-tab>
        </van-tabs>
    </div>
    <detail ref="detail"></detail>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import detail from "./detail";
import {calcLift} from '@/utils/index'

export default {
  components: { detail },
  data() {
    return {
      preClass: "basic-info",
      show: false,
      profitAnalysis: {}
    };
  },
  computed: {
    ...mapGetters(["currClient", "currDate",'currDateMonth','smallScale','currClientDetail']),
    calcLift(){
      return calcLift
    },
    companySurvey(){
      return [
             {
          title: "企业名称",
          value: this.currClientDetail.name
        },
        {
          title: "登记注册类型",
          value:this.$dict[this.currClientDetail.type_id]?this.$dict[this.currClientDetail.type_id].name:'',
        },
        {
          title: "税务资格信息",
          value:this.$dict[this.currClientDetail.tax_id]?this.$dict[this.currClientDetail.tax_id].name:'',
        }
      ]
    },
    financialInfo(){
      return [
        {
        title: "开户行",
          value: this.currClientDetail.open_bank
        },
            {
        title: "账号",
          value:this.currClientDetail.account
        },
            {
        title: "社会统一信用代码",
          value: this.currClientDetail.taxpayer_code
        },
      ]
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      let params = {
        begin_date: this.currDate,
        end_date: this.currDate,
        report_type: 1
      };
      this.$axios.post("/report/boss-report/get-report", params).then(res => {
        console.log("利润分析", res);
        if (res.success && res.rows) {
          let tabsData = {};
          res.rows.forEach(item => {
          if(item.key===1003||item.key===1104||item.key===1105||item.key===1204||item.key===1205||item.key===1304||item.key===1305||item.key===1404||item.key===1405){
            return
           }
            item = {
              ...item,
              maxRow:2,
              title:item.name,
              value:Number( item.formula),
              align: "around",
              click: this.handleTableClick,
              filter: "toThousandFilter",
              color: "blue"
            };
            if (item.key_type) {
              if (tabsData[item.key_type]) {
                tabsData[item.key_type].push(item);
              } else {
                tabsData[item.key_type] = [item];
              }
            }
          });
          this.profitAnalysis = tabsData;
        }
      }).finally(_=>{
         this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
    handleTableClick(data, index) {
      // 利润总额
      if(data.key_type==='利润总额'){
        return
      }
      this.$refs.detail.dateType = index;
      this.$refs.detail.type = data.key_type;
      this.$refs.detail.data = data;
      this.$refs.detail.show = true;
    }
  }
};
</script>

<style lang="less">
.basic-info {
  &-content {
    p {
      line-height: 1rem;
      margin: 15px 0;
    }
    .van-tabs__content {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/basic-info/index.vue